import axios from '../../service/index'
import React from 'react'
import { Button, Upload, message, Modal } from 'antd'
// const qiniuUpUrl = window.location.protocol === "https:" ? 'https://up-z1.qiniup.com' : 'http://up-z1.qiniup.com/';
const qiniuUpUrl = 'https://up-z1.qiniup.com'
class ImgQiniu extends React.Component {
	constructor(props) {
		super(props)
		let fileList = []
		let uploadUrl = null
		let proposalSize = ''
		console.log(props, 1)
		if (props.value) {
			fileList = [props.value] || []
			uploadUrl = props.value.url || ''
		}
		if (props.id === 'swiperUpload') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*266px'
		}
		if (props.id === 'qscode') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：120*120px'
		}
		if (props.id === 'circle') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*144px'
		}
		if (props.id === 'uploadUrl') {
			proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：68*68px'
		}
		if (props.id === 'advPic') {
			// proposalSize = '仅支持jpg/png/jpeg文件，且不超过2M，建议尺寸：700*266px;'
			proposalSize = '为了保证显示效果，请上传比例为16:9的图片，支持jpg、jpeg、png格式，文件大小不超过 2M'
		}
		this.state = {
			visible: false,
			bosObj: null,
			fileType: 'limit',
			scriptStatus: 'no',
			fileList: fileList,
			token: '',
			url: '',
			uploadUrl: uploadUrl,
			previewVisible: false,
			type: '',
			proposalSize: proposalSize
		}
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		if(nextProps.value?.url&&prevState.fileList.length<=0){
			let fileList = []
			let uploadUrl = ''
			fileList = [nextProps.value] || []
			uploadUrl = nextProps.value?.url || ''
			return {fileList,uploadUrl }
		}
		return null
	}
	handleOk() {
		this.setState({ visible: false })
	}
	componentDidMount() {
		this.getToken()
	}

	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
				this.props.getQiniuUrl(res.data.data.url)
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	handlePreview = async file => {
		this.setState({
			previewVisible: true,
		});
	}
	handleChange = ({ file, fileList }) => {
		console.log(fileList)
		if (file.percent === 100) {
			if (file.status === 'done') {

				file.type = this.state.type
				this.setState({
					uploadUrl: this.state.url + '/' + file.response.key
				})
				let fileL = {
					uid: fileList[0].uid,
					name: fileList[0].name,
					status: fileList[0].status,
					url: this.state.url + '/' + fileList[0].response.hash,
					type: fileList[0].type
				}
				this.setState({ fileList: [fileL] });
				// console.log(file)
				this.props.onChange(file)
			}
		}
		else if (file.status === 'removed') {
			this.setState({ fileList: [] },()=> {
				this.props.onChange()
			});
			
		}
	};
	showModal() {
		this.setState({ visible: true })
	}
	handleCancel = () => this.setState({ previewVisible: false });
	render() {
		const { fileList, previewVisible, uploadUrl } = this.state;
		const uploadButton = (
			<div>
				<Button>上传</Button>
			</div>
		);
		return (
			<div key={2}>
				<Upload
				key={3}
					accept=".png,.jpg,.jpeg,"
					action={qiniuUpUrl}
					fileList={fileList}
					listType='picture'
					beforeUpload={(file, fileList) => {
						this.setState({ type: file.type })
						const isLt10M = file.size / 1024 / 1024 <= 2;
						if (!isLt10M) {
							message.error("文件大小限制在2M以下！");
							return false;
						}
						this.setState({ fileList: fileList })
					}}

					onPreview={this.handlePreview}
					onChange={this.handleChange}
					onRemove={(file, fileList) => {
						console.log(file)
						// if (file.status === "removed") {
							console.log('removed2')
							this.setState({fileList:[]},()=> {
								this.props.onChange()
							})
							
							// }

					}}
					data={{ token: this.state.token }}
				>
					{this.state.fileList.length >= 1 ? '' : uploadButton}
				</Upload>
				<p style={{ fontSize: '12px', color: '#999999' }}>{this.state.proposalSize}</p>
				<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
					<img alt="example" style={{ width: '100%' }} src={uploadUrl} />
				</Modal>
			</div>
		)
	}
}

export default ImgQiniu